"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuButton = void 0;
const react_1 = __importDefault(require("react"));
const menu_styled_1 = require("./menu.styled");
const menu_label_1 = __importDefault(require("./menu-label"));
const base_react_components_1 = require("@navinc/base-react-components");
/** Button opens a menu list */
const MenuButton = ({ title, size, isOpen = false, setIsOpen, setIsSelected, tabIndex, index = -1, section, }) => {
    return (react_1.default.createElement(menu_styled_1.StyledButton, { size: size, onClick: (e) => {
            e.preventDefault();
            setIsOpen && setIsOpen(!isOpen);
            setIsSelected && setIsSelected(index);
        }, "$isOpen": isOpen, tabIndex: tabIndex, "aria-expanded": isOpen, "aria-controls": section },
        react_1.default.createElement(menu_label_1.default, { title: title }),
        react_1.default.createElement(base_react_components_1.Chevron, { "$isOpen": isOpen })));
};
exports.MenuButton = MenuButton;
exports.MenuButton.displayName = 'MenuButton';
exports.default = exports.MenuButton;
//# sourceMappingURL=menu-button.js.map